export const AdminConstants = {
  defaultPageName: 'admins',
  defaultPageId: 'admins',
  typeName: 'Admin',
};
